import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import s from './set-new-password-page.module.scss'
import { FormProvider, useForm } from 'react-hook-form';
import { auth } from '@shared/api/services' ;
import { Button } from '@shared/ui/button/button';
import { Input } from '@shared/ui/input/input';

export const SetNewPassword = () => {
	const methods = useForm({mode: 'onTouched'})
	const navigate = useNavigate()
	const { state } = useLocation()
	const { reset_token, phone } = state

  const handleSubmit = methods.handleSubmit(data => {
		const payload = {
			reset_token,
			phone,
			password: data.password,
			password_confirmation: data.password_confirmation
		}
	
		auth.resetPasswordReset(payload).then((res) => {
			if(res.status === 200){
				navigate('/login')
			}
		})
  })

	return (
		<div className={s.wrapper}>
			<div className={s.card}>
				<NavLink to={'/'} className={s.logo}>
					<img src={process.env.REACT_APP_STORAGE_URL + "images/logo.svg"} alt="Созвучно - сервис по поиску преподавателей музыки"/>
				</NavLink>
				<h2 className={s.title}>
					Восстановление пароля
				</h2>
				<FormProvider {...methods}>
					<form onSubmit={handleSubmit} className={s.form}>
						<Input 
							type="password" 
							placeholder='Новый пароль' name="password" 
							className={s.input}
							validation={{
								required: {
									value: true,
									message: 'Поле незаполнено',
								},
								minLength: {
									value: 8,
									message: 'Минимум 8 символов',
								},
								maxLength: {
									value: 50,
									message: 'Максимум 50 символов',
								},
							}}/>
						<Input 
							type="password" 
							placeholder='Повторите пароль' name="password_confirmation" 
							className={s.input}
							validation={{
								required: {
									value: true,
									message: 'Поле незаполнено',
								},
								minLength: {
									value: 8,
									message: 'Минимум 8 символов',
								},
								maxLength: {
									value: 50,
									message: 'Максимум 50 символов',
								},
								validate: value => value === methods.watch("password") || "Пароли не совпадают"
							}}/>
						<Button label='Восстановить' className={s.button}/>
					</form>
				</FormProvider>
			</div>
		</div>
	)
}
